{
  "client": {
    "details": "Details",
    "clientList": "Client List",
    "allClients": "All Clients",
    "fuseStart": "Fuse Start",
    "addClient": "Add Client",
    "contacts": "Contacts",
    "documents": "Documents",
    "companyLegalName": "Company Legal Name",
    "websiteURL": "Website URL",
    "clientStatus": "Client Status",
    "fuseStartDate": "Fuse Start Date",
    "fuseEndDate": "Fuse End Date",
    "feinBusinessNumber": "FEIN or Business Number",
    "corporateAddress": "Corporate Address",
    "programCountry": "Program Country",
    "country": "Country",
    "countryPlaceholder": "Choose your program's country",
    "unitedStates": "United States",
    "canada": "Canada",
    "remittanceInformation": "Remittance Information",
    "remittanceAddress": "Remittance Address",
    "bankingInformation": "Banking Information",
    "bankName": "Bank Name",
    "bankAccountType": "Bank Account Type",
    "bankAccountNumber": "Bank Account Number",
    "bankRoutingNumber": "Bank Routing Number",
    "stripeDetails": "Stripe Details",
    "noStripeAccountConnected": "No Stripe Account Connected",
    "addStripeDetails": "Add Stripe Details",
    "stripeUnavailableForCanada": "Stripe payouts are currently not available for clients located in Canada.",
    "accountDetails": "Account Details",
    "displayName": "Display Name",
    "noDisplayName": "No display name",
    "contactEmail": "Contact Email",
    "enterEmailAddress": "Enter email address",
    "linkedBankAccount": "Linked Bank Account",
    "updateBankAccount": "Update Bank Account",
    "completeBankingDetails": "Complete Banking Details",
    "routingNumber": "Routing Number",
    "last4": "Last 4",
    "retired": "Retired",
    "retireClient": "Retire Client",
    "retire": "Retire",
    "retireButton": "RETIRE",
    "retiringButton": "RETIRING...",
    "lastReportingPeriod": "Last Reporting Period",
    "retireWarning": "Warning: Retiring this Client will retire all its Facilities, Equipment, and any Equipment Usage data",
    "retireWarningEnd": "will be discarded.",
    "theLastReportingPeriod": "the last reporting period",
    "retireConfirmation1": "I understand that retiring this Client will also retire all its Facilities and Equipment.",
    "retireConfirmation2Start": "I understand that all usage data",
    "retireConfirmation2End": "will be discarded.",
    "selectPeriod": "Select Period...",
    "noProgramMessage": "A program must be added to this client before selecting the last reporting period."
  },
  "contacts": {
    "pointsOfContact": "Points of Contact",
    "pointsOfContactDescription": "All Admin users for this {{entityType}} will be considered points of contact.",
    "pointsOfContactDescriptionClient": "All Admin users for this Client and {{entityType}} will be considered points of contact.",
    "client": "Client",
    "corporateContacts": "Corporate Contacts",
    "remittanceContacts": "Remittance Contacts",
    "facilityContacts": "Facility Contacts",
    "contact": "Contact",
    "contactRole": "Contact Role",
    "contactName": "Contact Name",
    "contactEmail": "Contact Email",
    "contactPhone": "Contact Phone",
    "choose": "Choose..."
  },
  "documents": {
    "title": "Document Library",
    "uploadDocument": "Upload Document",
    "documentName": "Document Name",
    "documentType": "Document Type",
    "dateUploaded": "Date Uploaded",
    "uploadedBy": "Uploaded By",
    "noDocumentsFound": "No Documents Found",
    "noDocumentsMatchFilters": "No documents match the selected filters",
    "clearFilters": "Clear Filters",
    "characterLimit": "/500 characters",
    "noComments": "No comments",
    "saveChanges": "Save Changes",
    "cancelEditing": "Cancel Editing",
    "downloadDocument": "Download Document",
    "seeMore": "See More",
    "collapse": "Collapse",
    "editComments": "Edit Comments",
    "deleteDocument": "Delete Document",
    "deleteDocumentWarning": "Are you sure you want to delete this document?",
    "deleteDocumentConfirm": "I understand this action cannot be undone.",
    "processing": "Processing",
    "needsReview": "Needs Review",
    "selectDocumentType": "Select Document Type",
    "addComments": "Add Comments (optional)",
    "cancel": "Cancel",
    "upload": "Upload",
    "dropFiles": "Drop file here or click to",
    "browse": "browse",
    "selectedFile": "Selected File",
    "cannotDownloadWhileProcessing": "Cannot download while processing",
    "cannotDownloadFileNeedsReview": "Cannot download — file needs review",
    "searchByName": "Search by name",
    "downloadSelected": "Download Selected",
    "preparingDownload": "Preparing...",
    "all": "All",
    "filterDocuments": "Filter Documents",
    "bulkDownloadPartial": "{{downloaded}} document(s) downloaded, {{skipped}} skipped (processing or needs review).",
    "bulkDownloadUnavailable": "{{count}} selected document(s) cannot be downloaded right now (processing or needs review)."
  },
  "statements": {
    "statements": "Statements",
    "statementList": "Statement List",
    "incentiveStatements": "Incentive Statements",
    "summary": "Summary (Printable)",
    "details": "Details (Printable)",
    "viewIndividualPrograms": "View Individual Programs",
    "hideIndividualPrograms": "Hide Individual Programs",
    "viewIndividualProgram": "View Individual Program",
    "hideIndividualProgram": "Hide Individual Program",
    "noStatementsFound": "No Statements found",
    "allPrograms": "All Programs",
    "individualStatement": "Individual Statement",
    "downloadPDF": "Download PDF",
    "downloadCSV": "Download CSV",
    "detailedStatement": "Detailed Statement",
    "incentiveStatement": "Incentive Statement",
    "credits": "Credits",
    "accountEndingIn": "Account ending in",
    "creditPrice": "Credit Price",
    "totalValue": "Total Value",
    "recCost": "REC Cost",
    "brokerCost": "Broker Cost",
    "taxesOnCreditSale": "Taxes on Credit Sale",
    "taxesOnServices": "Taxes on Services",
    "fuseServiceFee": "FuSE Service Fee",
    "netIncentive": "Net Incentive",
    "totals": "Totals",
    "costRecoup": "Cost Recoup (if Applicable)",
    "grandTotal": "Grand Total",
    "calculationKey": "Calculation Key",
    "definition": "Definition",
    "taxesOnCreditSaleDefinition": "Applicable only to the BC LCFS program. Taxes assessed at 5% of Total Value.",
    "taxesOnServicesDefinition": "Applicable GST, HST, and PST assessed based on the Client headquarters province.",
    "creditsDefinition": "Credit generation is based on the amount of reported kWh used/dispensed by your electric equipment.",
    "creditPriceDefinition": "Credit price is determined by the value of each credit sold to regulated entities (oil & gas companies) on the open market.",
    "recCostDefinition": "Renewable Energy Certificates (RECs) are megawatt-hrs. of clean electricity procured on your behalf to enhance the amount of credits generated, when financially beneficial. Purchasing RECs at this cost increases credits and revenue generated.",
    "brokerCostDefinition": "Administrative cost associated with brokerage services, REC procurement, and contracting with regulated entities.",
    "fuseServiceFeeDefinition": "Agreed upon commission retained by FuSE after REC Cost and Broker Cost are subtracted.",
    "caFuseServiceFeeDefinition": "Agreed upon commission retained by FuSE.",
    "costRecoupDefinition": "Funds withheld in cases where FuSE has fronted cost of metering hardware or other Exchange activities.",
    "netIncentiveDefinition": "Amount remitted to your organization after all costs and fees have been subtracted.",
    "incentiveStatementNotice": "The incentive statement below reflects the credits generated by your organization's enrolled electric asset/equipment in applicable state, provincial, or federal clean fuel standard program. For questions or additional information, please contact our team at support@usefuse.com, or through the chat feature in the app."
  },
  "commissions": {
    "commissions": "Commissions",
    "fuseCommissions": "FuSE Commissions",
    "percentage": "Percentage",
    "fixedRate": "Fixed Rate",
    "effectiveStartDate": "Effective Start Date",
    "effectiveEndDate": "Effective End Date",
    "salesCommissions": "Sales Commissions",
    "referralCommissions": "Referral Commissions",
    "referralPartner": "Referral Partner"
  },
  "user": {
    "user": "User",
    "users": "Users",
    "company": "Company",
    "lastLogin": "Last Login",
    "userList": "User List",
    "addUser": "Add User",
    "userRole": "User Role",
    "userStatus": "User Status",
    "inactive": "Inactive",
    "email": "Email",
    "phone": "Phone",
    "noUsersFound": "No Users found",
    "userInformation": "User Information",
    "contactInformation": "Contact Information",
    "created": "Created",
    "updatePassword": "Update Password",
    "currentPassword": "Current Password",
    "newPassword": "New Password",
    "confirmNewPassword": "Confirm New Password",
    "passwordRegex": "Password must be at least 16 characters long and must contain at least one uppercase letter, one lowercase letter, one number, and one special character (!@#$%^&*)"
  }
}
